import React from "react";

// Carte de section d'une fiche : titre, actions à droite, corps.
const FicheSection = ({ id, title, actions = null, children, className = "" }) => {
  const titleId = id ? `${id}-title` : undefined;
  return (
    <section className={`fiche-section list-card ${className}`.trim()} aria-labelledby={titleId}>
      {(title || actions) && (
        <header className="fiche-section__header">
          {title && (
            <h2 className="fiche-section__title" id={titleId}>
              {title}
            </h2>
          )}
          {actions && <div className="fiche-section__actions">{actions}</div>}
        </header>
      )}
      <div className="fiche-section__body">{children}</div>
    </section>
  );
};

export default FicheSection;
